<template>
  <div class="heatmap__popup--wrap">
    <div class="popup__content">
      <i class="icon" :class="iconClass"></i>
      <p class="message" v-html="$t(`heatmap.alert.${dialogType}`)"></p>

      <ui-button @click="$emit('onCloseClick')">
        {{ $t('heatmap.alert.button.confirm') }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton'

export default {
  name: 'HeatmapPopup',
  components: {
    UiButton
  },
  props: {
    dialogType: {
      type: String,
      required: true
    }
  },
  computed: {
    iconClass () {
      switch (this.dialogType) {
        case 'includeNoStreamDate':
        case 'noStreamDisplay':
          return 'icon--not-empty-warning'
        case 'noStreamByDate':
        case 'noStreamEventIncludeNoStreamDate':
          return 'icon--empty-warning'
        default:
          return 'icon--heatmap-popup'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .heatmap__popup--wrap {
    @include positionXYcenter;
    z-index: 10;
    width: 430px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-bottom: 25px;
    text-align: center;

    i {
      display: block;
      margin: 50px auto 0;
    }

    .message {
      margin-top: 10px;
      padding-left: 15px;
      padding-right: 15px;
      font-size: 14px;
      line-height: 1.43;
      text-align: center;
      font-weight: 500;
      color: #2f2f2f;
    }

    button {
      margin-top: 40px;
    }
  }
</style>
